<template>
  <div>
    <loader :loading="loading"/>
    <div class="l-row">
      <form-group :label="$t('brand.label')" :columns="6">
        <select v-model="filters.brand" class="form-select">
          <option :value=null>Todas</option>
          <option v-for="brand in brands" :value="brand" :key="brand">{{ brand }}</option>
        </select>
      </form-group>

      <form-group :label="$t('department.label')" :columns="6">
        <select v-model="filters.category" class="form-select">
          <option :value=null>Todas</option>
          <option v-for="department in departments" :value="department" :key="department">{{ department }}</option>
        </select>
      </form-group>
    </div>
  </div>
</template>

<script>
  import Loader from '@/components/template/Loader'
  import api from '@/api'
  import FormGroup from '@/components/template/FormGroup'

  export default {
    data: () => ({
      brands: [],
      departments: [],
      filters: {
        brand: null,
        department: null,
        category: null
      },
      loading: false
    }),
    props: {
      module: {
        type: Object,
        required: true
      }
    },
    mounted () {
      this.loading = true

      api.getBrands(this.module.type, this.module.identifier)
        .then(brands => { this.brands = brands })
        .catch(() => (this.brands = []))

      api.getCategories('marketplace', 'sicredi')
        .then(categories => {
          this.departments = categories
          this.loading = false
        })
        .catch(() => (this.departments = []))
    },
    components: {
      FormGroup,
      Loader
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// Sicredi.vue?03810842